addEventListener('DOMContentLoaded', () => {
    const blocks = [...document.querySelectorAll('div.client-block')]
    for (let i = 0; i < blocks.length; i++) {
        new ClientBlock(blocks[i], 'S')
    }
})

export default class ClientBlock {

    /**
     * @param {HTMLElement} element 
     * @param {String} startAt 
     */
    constructor(element, startAt = 'A') {
        this.element = element

        // The scroll element.
        this.scrollElement = document.querySelector('div.scroll-container')
        this.items = [...this.scrollElement.querySelectorAll('.client')]
        if (!this.items) return
        
        // Duplicate
        this.duplicateScroll = this.scrollElement.cloneNode(true)
        this.duplicateScroll.classList.add('duplicate')
        this.scrollElement.parentNode.appendChild(this.duplicateScroll)
        this.duplicateItems = [...this.duplicateScroll.querySelectorAll('.client')]
        
        // <content> width
        this.windowWidth = this.element.parentElement.offsetWidth
        this.duplicateScroll.style.transform = 'translateX(' + this.windowWidth + 'px)'
        
        // Calculations.
        const marginLeft = this.getMargin(this.items[0])
        this.itemWidth = this.items[0].offsetWidth + (marginLeft * 2)
        this.maxLength = (this.itemWidth * this.items.length)
        this.visibleItems = this.windowWidth / this.itemWidth

        this.init(startAt)
    }

    init(letter) {
        this.startAt(letter)

        setInterval(_ => {
            const max = -this.maxLength + (this.windowWidth)
            const current = this.getTranslateX(this.scrollElement)
            const duplicate = this.getTranslateX(this.duplicateScroll)

            if ((current < max || duplicate < this.windowWidth) && duplicate > -this.windowWidth) {
                this.setVisible()
                const x = duplicate - 1
                this.duplicateScroll.style.transform = 'translateX(' + x + 'px)'
            } else {
                this.setVisible(false)
                this.duplicateScroll.style.transform = 'translateX(' + this.windowWidth + 'px)'
            }

            if (current <= (-this.maxLength)) {
                this.scrollElement.style.transform = 'translateX(0%)'
                return
            }

            const n = current - 1
            this.scrollElement.style.transform = 'translateX(' + n + 'px)'
        }, 10)
    }

    /** Finds the first item with the given letter and sets the scroller to its position. */
    startAt(letter) {
        var iterationCounter = 0

        const itemWithLetter = [...this.scrollElement.querySelectorAll('.client p')]

        let marginLeft = this.getMargin(this.items[0])
        let itemWidth = this.items[0].offsetWidth + (marginLeft * 2)

        for (let i = 0; i < itemWithLetter.length; i++) {
            const item = itemWithLetter[i]

            iterationCounter++

            if (item.innerHTML.charAt(0).toLowerCase() === letter.toLowerCase()) {
                this.scrollElement.style.transform = `translateX(-${itemWidth * iterationCounter}px)`
                break
            }
        }
    }

    //
    // Helpers.

    /** Returns values of computed margin. */
    getMargin(element) {
        const computed = window.getComputedStyle(element)
        return parseInt(computed.marginLeft)
    }

    /** Returns values of computed translateX. */
    getTranslateX(element) {
        const computed = window.getComputedStyle(element)
        const matrix = new DOMMatrix(computed.transform)
        return matrix.m41
    }

    /** Hides and shows the duplicate when necessary. V for Visible. */
    setVisible(v = true) {
        const array = [this.visibleItems, this.duplicateItems.length]
        for (let i = 0; i < array[v ? 0 : 1]; i++) {
            this.duplicateItems[i].style.display = v ? 'block' : 'none'
            if (this.items[i]) this.items[i].style.visibility = v ? 'hidden' : 'visible'
        }
    }
}
